// DS: i4.53
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Preset: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          d="M8 4a1 1 0 0 0-2 0v8a1 1 0 1 0 2 0V4ZM10 17H8v3a1 1 0 1 1-2 0v-3H4a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2ZM16 20a1 1 0 1 0 2 0v-8a1 1 0 1 0-2 0v8ZM16 7h-2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2V4a1 1 0 1 0-2 0v3Z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
Preset.displayName = 'Preset';

export default Preset;
